$(document).ready(function() {
	var maxLength;

	// Determine the maxLength based on the screen width
	function setMaxLength() {
		if ($(window).width() >= 1200) {
			maxLength = 240;
		} else if ($(window).width() >= 768) {
			maxLength = 150;
		} else {
			maxLength = 50;
		}
	}

	function truncateText() {
		$('.pd-c-simpletextblock__message').each(function() {
			var $this = $(this);
			var originalText = $this.data('original-text');

			if (!originalText) {
				originalText = $this.text().trim();
				$this.data('original-text', originalText);
			}

			if (originalText.length > maxLength) {
				$this.text(originalText.substring(0, maxLength) + '...');
			} else {
				$this.text(originalText);
			}
		});
	}

	setMaxLength();
	truncateText();

	// Update maxLength when the window is resized
	$(window).resize(function() {
		setMaxLength();
		truncateText();
	});
});
